
// import bsv from "bsv"
// const Run = require("runlib")

import NoFetchBlockchain, { isNoFetchBlockchain } from "../shared/NoFetchBlockchain";
import { getLog } from "../helpers/helpers";
import { isDevMode } from "./Runcraft";
import pDebounce from "../helpers/pDebounce";

// // for nodejs oracle server // might be deprecated & not required anymore
// import bsv from "bsv"
// import Run from "run-sdk"

// -------------------------------------

export function is_string(obj) {
    return (typeof obj === 'string' || obj instanceof String)
}

/*
function hex_to_ascii(str1){
    var hex  = str1.toString();
    var str = '';
    for (var n = 0; n < hex.length; n += 2) {
        str += String.fromCharCode(parseInt(hex.substr(n, 2), 16));
    }
    return str;
}
*/


/**
 * DO NOT ADD run as a property otherwise logging this class would log privkeys !
 * instead, pass it as an arg to each function that requires it
 * 
 * @param {} run 
 * @param {*} trusted_txids 
 */
export default class OraclesUtils {
    constructor(run, trusted_txids = []) {
        this.DEBUG = false

        this.log = (...args) => { console.log("OraclesUtils:", ...args) }

        if (trusted_txids) {
            for (let i = 0; i < trusted_txids.length; i++) {
                run.trust(trusted_txids[i].split('_')[0])
            }
        }
    }

    async displayPurse(run) {
        await run.sync()
        this.log(
            "\n purse address:", run.purse.address,
            "\n purse balance:", await run.purse.balance(), "sats"
        )
    }


    /**
    * helper function to recursively trust all required txs to load a trusted contract
    * (the function itself is not a recursive function, but it trusts recursively the refs of a contract)
    * 
    * @param {*} run - a Run instance
    * @param {runtx_string} contract_origin 
    * @param {bool} with_sync - use true on server, false in user apps as it slow downs the app a lot
    * 
    * BEWARE DO NOT auto-SYNC LOADED CONTRACTS IN THIS FUNCTION IT WILL SLOW THE APP LIKE HELL
    */
    async load_trustRecursive(run, contract_origin, with_sync = false) {
        const log = getLog("load_trustRecursive(): ")

        // safety check
        if (!contract_origin.includes('_o')) {
            throw new Error("load_trustRecursive: invalid contract_origin, should finish with '_oX' but got: " + contract_origin)
        }

        // we must create it only once and then reutilize it for it to work
        // but me scope it to only this key
        if (!this.debounced_load_trustRecursive) this.debounced_load_trustRecursive = {}
        const key = contract_origin + "_" + with_sync
        // log("before:", this.debounced_load_trustRecursive[key], "for key=", key)
        if (!this.debounced_load_trustRecursive[key]) {
            // pDebounce.promise will return the first result for all those that have been called in parallel
            this.debounced_load_trustRecursive[key] = pDebounce.promise(
                async () => { return await this._load_trustRecursive(run, contract_origin, with_sync) }
            ).bind(this)
        }
        const start_time = Date.now()
        const res = await this.debounced_load_trustRecursive[key]()
        const time_spent = Date.now() - start_time
        if (with_sync) log("spent", time_spent, "ms with_sync=", with_sync, "for contract_origin=", contract_origin)
        return res
    }
    async _load_trustRecursive(run, contract_origin, with_sync = false) {
        const infiniteLoop_limit = 10 * 1000
        let infiniteLoop_i = 0

        // if we are on a no-fetch blockhain then trying to sync would create an infinite loop of error handling
        const is_noFetchBlockchain = isNoFetchBlockchain(run.blockchain)
        if (is_noFetchBlockchain) with_sync = false

        const function_id = "_load_trustRecursive(with_sync=" + String(with_sync)
            + ",is_noFetchBlockchain=" + String(is_noFetchBlockchain) + ",contract_origin=" + String(contract_origin) + "):"
        const log = getLog(function_id)

        if (!contract_origin) {  // happens on oracle server ?
            console.error(function_id + " got empty contract_origin")
            return
        }

        // console.log("Runcraft.load_contract: calling trustRecursive for "+contract_origin)
        // await this.OraclesUtils.trustRecursive(contract_origin)
        // we replace the trustRecursive by the while loop below which should only trust
        // the required txid and not all of them, so should load faster

        var Contract
        try {
            let start_time = Date.now()
            let times = []

            run.activate()  // avoid "This Run instance is not active"

            const isbanned = await run.cache.get("ban://" + contract_origin)
            // log("run.cache.get('ban://...'): ",isbanned)
            if (isbanned !== false) {
                log("unbanning(1)", contract_origin)
                await run.cache.set("ban://" + contract_origin, false)
            }
            times.push(Date.now() - start_time)
            log("trust(1)", contract_origin.split('_')[0])
            run.trust(contract_origin.split('_')[0])
            times.push(Date.now() - start_time)

            /*const cached = await run.cache.get("jig://" + contract_origin)
            if (cached) {
                log("jig found in cache", contract_origin, (isDevMode ? cached : ""))
                // and then we don't use it ? what should we do with it ?
            }*/

            log("load(1)", contract_origin)
            run.activate()  // avoid "This Run instance is not active"
            // this is very slow in devmode on first load but not in prod, so it's fine
            // it's probably due to run cache that takes more time to load in dev mode
            Contract = await run.load(contract_origin)
            times.push(Date.now() - start_time)
            log("times in ms:", times, "for", contract_origin)
        }
        catch (error) {
            const txh_regex = /[a-fA-F0-9]{64}/
            // extract txid from error to trust it and retry
            var while_error = error
            while (while_error) {
                error = while_error // copy from recursive
                while_error = null // reset to end loop
                var err_mess = String(error)
                log("caught Error:", err_mess)

                var txh_to_trust = null, location_to_unban = null
                // beware: we can have a message like: "cannot load xx_o2 because we cannot load untrusted xxx"
                while (err_mess) {
                    infiniteLoop_i += 1
                    if (infiniteLoop_i > infiniteLoop_limit) {
                        console.error(function_id + " reached infinite loop of " + infiniteLoop_limit + ". " + err_mess, error)
                        return // abort
                    } else if (infiniteLoop_i % 1000 === 0) {
                        console.warn(function_id + " potential infinite loop. current iteration: " + infiniteLoop_limit + ". " + err_mess, error)
                    }
                    // if we have a txh and also a txid
                    if (err_mess && txh_regex.exec(err_mess) && err_mess.split("_").length > 1) {
                        // here we try to extract the txid from any message => much more versatile
                        // format is always: 64 chars + "_" + 2 chars (ex: "_d0" or "_o1")
                        let unban_txh = err_mess.split("_")[0].slice(-64)
                        let unban_suffix = '_' + err_mess.split("_")[1].slice(0, 2)
                        location_to_unban = unban_txh + unban_suffix
                        log("location_to_unban", location_to_unban)

                        // if txh seems valid, we try to unban
                        if (txh_regex.exec(unban_txh)) {
                            log("unbanning(2)", location_to_unban)
                            await run.cache.set("ban://" + location_to_unban, false)
                            txh_to_trust = location_to_unban.split('_')[0]  // safety convert txid to txh
                        }
                    }
                    else {  // no "_oX" in it => use a regex to extract the txhash
                        var array_txh = txh_regex.exec(err_mess)
                        log("array_txh = ", array_txh)

                        if (array_txh && array_txh.length > 0) {
                            txh_to_trust = array_txh[0]
                        }
                        else {
                            console.warn(function_id,
                                "no more txh to load found, to check manually: remaining err_mess=",
                                err_mess, ", txh_to_trust=", txh_to_trust,
                            )
                            if (err_mess.includes("Bad location")) {
                                console.error(function_id + " Error: " + err_mess)
                                return  // abort to avoid infinite loop
                            }
                        }
                    }

                    // now that we extracted it, let's trust & unban it
                    if (txh_to_trust) {
                        // remove the extracted txh_to_trust from the err_mess so we can search for other ones
                        if (location_to_unban) err_mess = err_mess.split(location_to_unban)[1]
                        else err_mess = err_mess.split(txh_to_trust)[1]

                        log("extracted txh_to_trust=", txh_to_trust,
                            "\n > when loading contract_origin=", contract_origin,
                            "\n > remaining err_mess=", err_mess)

                        txh_to_trust = txh_to_trust.split('_')[0]  // safety convert txid to txh
                        log("trust(3)", txh_to_trust)
                        run.activate()
                        run.trust(txh_to_trust)
                    }
                    else { // no more tx to search for in err_mess
                        err_mess = null
                    }
                }

                // now we can retry loading the contract_origin
                try {
                    /* // these shouldn't be needed a second time
                    log("unbanning(3)",contract_origin)
                    await run.cache.set("ban://"+contract_origin, false)
                    log("trust(2)",contract_origin.split('_')[0])
                    run.trust(contract_origin.split('_')[0])
                    */

                    log("load(2)", contract_origin)
                    run.activate()  // avoid "This Run instance is not active"
                    Contract = await run.load(contract_origin)
                }
                catch (error) {
                    while_error = error
                }
            }
        }
        if (with_sync && Contract) {
            try {
                await Contract.sync()
            } catch (syncError) {
                console.error(function_id + "Contract.sync() failed, continuing with unsynced contract:", syncError.message || syncError)
            }
        }
        log("finished for ", contract_origin)
        return Contract
    }
}

/*
example of messages:

---
TrustError: Cannot load untrusted code via replay: fcdd8b2d934b6b03f9c34cfa120f26f44a7c16486900a28bd7ca38ee164cc4cc

Hint: Trust this txid using run.trust(txid) if you know it is safe

---
Error: Failed to load banned location: 8485396d40add432f3cd5c7294a378fc498845949614c971b146d02d2083e6b2_o1

Reason: TrustError: Cannot load untrusted code via replay: 8485396d40add432f3cd5c7294a378fc498845949614c971b146d02d2083e6b2

Hint: Trust this txid using run.trust(txid) if you know it is safe

Hint: If you wish to unban this location: await run.cache.set('ban://8485396d40add432f3cd5c7294a378fc498845949614c971b146d02d2083e6b2_o1', false)
---
*/
